import { Trait } from './traits/trait';

export type OutcomeTable = Trait[];

const outcomeTable = {
  getTotalWeighting(table: OutcomeTable) {
    let total = 0;
    for (const { weight } of table) {
      total += weight;
    }
    return total;
  },
  pickOutcome(table: OutcomeTable, rn: number): Trait {
    let runningWeighting = 0;
    for (const outcome of table) {
      runningWeighting += outcome.weight;
      if (rn < runningWeighting) {
        return outcome;
      }
    }
    throw new Error(
      'Random number pick exceeds total weighting of outcome table'
    );
  }
};

export default outcomeTable;
